<script setup>
defineProps({
  categoria: { type: Object, required: true },
  listas: { type: Object, default: () => ({}) }
})

const getTextoLista = (lista, codigo) => {
  if (!lista || !codigo) return codigo || '-'
  const item = lista.find(i => String(i.idListaClienteItem) === String(codigo))
  return item ? item.textoLista : codigo
}

const getTipoBadgeClass = (tipo) => {
  if (!tipo) return 'bg-secondary'
  const t = tipo.toUpperCase()
  if (t.includes('RECEITA') || t.includes('ENTRADA')) return 'bg-success'
  if (t.includes('DESPESA') || t.includes('SAÍDA') || t.includes('SAIDA')) return 'bg-danger'
  if (t.includes('CUSTO')) return 'bg-warning text-dark'
  return 'bg-info text-dark'
}
</script>

<template>
  <div class="mb-1">
    <div :style="{ paddingLeft: ((categoria.nivel || 1) - 1) * 24 + 'px' }" class="d-flex align-items-center gap-1 py-1">
      <span class="text-muted small font-monospace" style="min-width: 50px;">{{ categoria.codigoEstruturado }}</span>
      <span class="small text-muted">—</span>
      <span class="small">{{ categoria.nome }}</span>
      <span v-if="!categoria.idCategoriaFinanceiraPai" class="badge ms-1" :class="getTipoBadgeClass(categoria.lstTipoMovimentacao)" style="font-size: 0.65rem;">
        {{ getTextoLista(listas.LstTipoMovimentacao, categoria.lstTipoMovimentacao) || categoria.lstTipoMovimentacaoTexto || '---' }}
      </span>
    </div>
    <template v-if="categoria.subcategorias && categoria.subcategorias.length > 0">
      <ReportItemCategoria v-for="sub in categoria.subcategorias" :key="sub.idCategoriaFinanceira" :categoria="sub" :listas="listas" />
    </template>
  </div>
</template>
